import { Button } from "@/components/ui/Button";

/**
 * CTASection Component
 * Full-width call-to-action banner
 */
export function CTASection() {
  const ctaSectionBg = `${window.template_root}/src/public/img/not-sure.jpg`;
  const acfData = window.post_template || [];
  const ctaLink = window.cta_link || "#";

  return (
    <section
      className="bg-(image:--ctaSectionBg) bg-cover bg-center bg-no-repeat
                        relative overflow-hidden text-center min-h-[600px]
                        flex items-center rounded-[1.5rem]
                        max-md:min-h-[340px] max-md:px-6 max-md:rounded-[1.5rem] bg-white"
      style={{ "--ctaSectionBg": `url('${ctaSectionBg}')` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 cta-overlay z-[1]" />

      {/* Content */}
      <div
        className="relative z-[2] max-w-[600px] mx-0 ml-16 flex flex-col items-center gap-6
                      max-md:gap-3 max-md:max-w-none max-md:mx-auto"
      >
        <h2
          className="font-family-title text-[2.8rem] font-normal text-white leading-tight mb-0
                       max-md:text-[1.85rem] max-md:leading-[1.25] max-md:mb-0"
        >
          Not sure what product is best for you?
        </h2>
        <p
          className="text-white/80 text-xl leading-relaxed font-[420]
                      max-md:text-base max-md:leading-relaxed"
        >
          Answer a few quick questions, and we'll match you with the right Naori
          products for your body, your goals, and your lifestyle.
        </p>
        <Button
          href={ctaLink}
          className="mt-0 bg-secondary !text-green max-md:mt-2 max-md:w-fit max-md:py-3.5 max-md:px-8"
        >
          {acfData.tr_cta_text}
        </Button>
      </div>
    </section>
  );
}

export default CTASection;
